import { createSlice } from '@reduxjs/toolkit'
import { fetchBoxycats } from './actions/fetchBoxycats'
import { AppState } from 'state'

interface Item {
  tokens: string[]
  loading: string
}

export const boxyCatsSlice = createSlice({
  name: 'boxycats',
  initialState: { tokens: [], loading: 'idle' } as Item,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchBoxycats.rejected, state => {
        state.loading = 'failed'
      })
      .addCase(fetchBoxycats.pending, state => {
        state.loading = 'loading'
      })
      .addCase(fetchBoxycats.fulfilled, (state, action) => {
        state.loading = 'idle'
        state.tokens = action.payload.tokens
      })
  }
})

export const selectBoxyCats = (state: AppState) => state.boxycats

export default boxyCatsSlice.reducer
